var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"TwoColumnsBoxed"}},[_c('div',{staticClass:"column-left"},[_vm._t("column-left")],2),_c('div',{staticClass:"column-right"},[_c('div',{staticClass:"box"},[_vm._t("column-right")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }